import { makeComponent } from '../core';
import React from 'react';

export const ButtonGroup = makeComponent( class extends React.Component<{$id:string}>{
    render(){
        return (<div data-elem-id={this.props.$id}>{this.props.children}</div>);
    }
});